module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.684 8.949l-5.935 17.803a.5.5 0 01-.934.04l-3.403-7.942a.5.5 0 00-.262-.262l-7.941-3.403a.5.5 0 01.039-.934L23.05 8.316a.5.5 0 01.633.633zM9.623 14.9l5.05 2.164a.5.5 0 01.262.262l2.164 5.05 3.739-11.215z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-near-me-outlined.svg
// module id = 725
// module chunks = 0